/*
 payment/view-amountinput.js

 import view-amountinput from ...

 -- supply callback to invoke on click --
 view-amountinput.init({cb });

 return:
 see api

 --delete button and eventhandlers --
 view-amountinput.close();
 */
import actions from '../../common/lib/utils/actions.js';
import core from '../../common/lib/core.js';
import validateAmount from './validate-amount.js';
import viewTextkeys from '../../commonview/lib/view-textkeys.js';
import viewFirstTimeUkDepositLinkCreator from './view-ukFirstTimeDepositLink.js';
import currencyFormatter from './../../../libs/currency-formatter.js';
import { getLocale } from './../../../libs/locale.js';


const classnameShow = 'u-show';
const classnameHide = 'u-hide';
const classnameInputerror = 'input-wrap__error';
const create = core.create;
const delayToProcessAmountField = 500;
let viewFirstTimeUkDepositLink;
let textkeysObj = {};

function createInputamount(eventFilter) {
	const cName = `${eventFilter} payment__input-amount input-wrap__input input-wrap__input--large u-text-c u-pl1 u-pr1`;
	return create({
		type: 'input',
		class: cName,
		autocomplete: 'off',
		name: 'amount',
		'input-type': 'tel',
		placeholder: textkeysObj['deposit-amount']
	});
}

function createLimitsFeedback(txt) {
	const elm = create({
		type: 'small',
		class: 'payment__amount-info u-pos-c u-text-c'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function show(elm) {
	core.removeClass(elm, classnameHide);
	core.addClass(elm, classnameShow);
}

function hide(elm) {
	core.removeClass(elm, classnameShow);
	core.addClass(elm, classnameHide);
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	/* this handler is a wrapper that filters out values from the target element,
	and then applies the callback-argument on these values */
	const eventFilterSelector = `.${eventFilterSeparatorClassname}`;

	function cb(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		const elm = p.elm;
		const value = elm && elm.value;
		const text = elm && elm.text;
		onEventCb({
			value,
			text
		});
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	core.handle(e, eventFilterSelector, cb, true);
}

function displayFeedback(feedbackelm, txt) {
	if (txt) {
		feedbackelm.innerHTML = txt; // eslint-disable-line no-param-reassign
		show(feedbackelm);
	} else {
		feedbackelm.innerHTML = ''; // eslint-disable-line no-param-reassign
		hide(feedbackelm);
	}
}

function publishOrFeedback(digits, amFeedback) {
	if (digits || digits === 0) {
		/* a valid amount */
		actions.viewAmountInput({
			amount: digits
		});
	} else {
		/* hide feedback if amount is empty. */
		displayFeedback(amFeedback, null);
	}
}

function createLimitFeedback(p) {
	/* arguments:
	 within,above, below, limitReached, within, above, below, -- booleans
	 reachmessage: textkeysObj['mobile-deposit-limit-reached-text'],
	 belowmessage: textkeysObj['min-limit-exceeded'],
	 withinmessage: textkeysObj['max-limit-exceeded'],
	*/
	const currency = p.currency;
	const minLimit = currencyFormatter.format(p.min, currency, getLocale());
	const maxLimit = currencyFormatter.format(p.max, currency, getLocale());
	const abovemessage = p.abovemessage || 'amount is above';
	const belowmessage = p.belowmessage || 'amount is below';
	const reachmessage = p.reachmessage || 'limit is reached';
	const withinmessage = p.withinmessage; // normally empty
	let amountLimitFeedback = '';
	if (p.limitReached) {
		amountLimitFeedback = reachmessage;
	} else if (p.above) {
		amountLimitFeedback = `${abovemessage} ${maxLimit}`;
	} else if (p.below) {
		amountLimitFeedback = `${belowmessage} ${minLimit}`;
	} else if (p.within) {
		amountLimitFeedback = withinmessage;
	}
	return {
		amountLimitFeedback
	};
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	core.addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	core.removeListener(elm, eventType, handler);
	return null;
}

export default {
	create(p) {
		let elements = {};
		let userHasStartedTyping = false;
		// const CHANGE = 'change'; // 'change' event submits when a new value is assigned, for example when the user clicks outside the amountfield
		const CLICK = 'click';
		const FOCUSIN = 'focusin'; // 'focusin' event submits when the element is about to get focus, and bubbles (only difference from 'focus'event)
		const INPUT = 'input'; // 'input' event submits whenever the inputfields input is altered
		const classNameEventFilter = 'js-eventfilter-viewamountinput';
		const clickcb = ((p && p.clickcb) || function empty() {});
		let limitReached = false;
		let previousInputEventTime = null;
		let lastTimeOutIdForAmountField = null;
		textkeysObj = viewTextkeys.depositflow();
		elements.wrap = (elements.wrap || create('label', 'payment__label-amount input-wrap u-mb1 u-db u-relative u-full-width-break-container')); // createLabelamount()); // wrapper
		elements.inputamount = (elements.inputamount || createInputamount(classNameEventFilter));
		elements.amountLimitsFeedback = (elements.amountLimitsFeedback || createLimitsFeedback('Min/Max: '));
		elements.amountfeedback = (elements.amountfeedback || create('div', 'input-wrap__error-display payment__feedback grid-u-sm-1 u-hide')); // createFeedback('amount feedback is written here'));
		elements.wrap.appendChild(elements.inputamount);
		elements.wrap.appendChild(elements.amountLimitsFeedback);
		elements.wrap.appendChild(elements.amountfeedback);
		viewFirstTimeUkDepositLink = viewFirstTimeUkDepositLinkCreator.create();
		elements.wrap.appendChild(viewFirstTimeUkDepositLink.wrap);
		viewFirstTimeUkDepositLink.hide();

		function callbackOnClick() {
			/* generally used to display an preset list of amounts, for example Siru-method*/
			clickcb();
		}

		function callbackOnFocusin() {
			/* focusin */
			elements.inputamount.value = '';
			elements.inputamount.placeholder = '';
		}

		function callbackOnInput() {
			/* input: fires when the elements input value changed.*/
			/* this or the focusinhandler or for siru the clickhandler indicates
			that the user begun typing, and then the inputfield won't be updated
			from fees-and-limits until 'hide' is invoked. */
			userHasStartedTyping = true;
			const val = elements.inputamount.value;
			const digits = validateAmount.keepDigits(val);
			const currentInputEventTime = new Date();
			elements.inputamount.value = digits;
			/*  --------delay------------------  */
			// after some time the amountfield is evaluated even tough the focus may still be in the field
			previousInputEventTime = (previousInputEventTime || currentInputEventTime);
			const timeIsOut = (currentInputEventTime.getMilliseconds() - previousInputEventTime.getMilliseconds() <= delayToProcessAmountField);
			if (timeIsOut && lastTimeOutIdForAmountField) {
				window.clearTimeout(lastTimeOutIdForAmountField);
			}
			lastTimeOutIdForAmountField = setTimeout(() => {
				publishOrFeedback(digits, elements.amountfeedback, elements.inputamount);
				lastTimeOutIdForAmountField = null;
			}, delayToProcessAmountField);
			/*  --------------------------  */
		}
		let clickHandler = addListeners(elements.wrap, callbackOnClick, classNameEventFilter, CLICK);
		let focusinHandler = addListeners(elements.wrap, callbackOnFocusin, classNameEventFilter, FOCUSIN);
		let inputHandler = addListeners(elements.wrap, callbackOnInput, classNameEventFilter, INPUT);

		return {
			wrap: elements.wrap,
			show(disabled) {
				/* for some paymentmethods (Siru) the inputfield is only allowed to be updated from a selectionlist
				and thus the inputfield is disabled.
				 If the limit is reached, the inputfield is disabled anyhow. */
				const disVal = (limitReached || disabled);
				//elements.inputamount.disabled = disVal;
				if (disabled) {
					userHasStartedTyping = false;
				}
				show(elements.wrap);
			},
			hide() {
				// userHasStartedTyping = false;
				hide(elements.wrap);
			},
			getValidAmount() {
				const val = elements.inputamount.value;
				const digits = validateAmount.keepDigits(val);
				return (digits || null);
			},
			update(state) {
				const firstTimeUk = ((state && state.first_time_uk_deposit) && state.first_time_uk_deposit.isFirstTime);
				if (state.first_time_uk_deposit) {
					/* this state will tell if the link shall be present or not */
					if (firstTimeUk) {
						viewFirstTimeUkDepositLink.show();
					}
				}
				if (state.paymentmethods) {
					const newMethodSelected = state.paymentmethods.methodswitch;
					if (newMethodSelected) {
						userHasStartedTyping = false;
					}
				}
				if (state.fetch_fees_and_limits) {
					const feeBasedOn = state.fetch_fees_and_limits.feeBasedOn;
					const within = state.fetch_fees_and_limits.limitWithin;
					const above = state.fetch_fees_and_limits.limitAbove;
					const below = state.fetch_fees_and_limits.limitBelow;
					limitReached = state.fetch_fees_and_limits.limitReached;

					if (!userHasStartedTyping && (feeBasedOn || feeBasedOn === '0')) {
						/* this will update the value in the inputfield according to the value used to create the summary below.
						This will only be done until the user inputs a new value.
						*/
						elements.inputamount.value = feeBasedOn;
					}
					/*
					 when value is within limits, the 'max...min...' text is displayed
					 when value is outside limits the 'max...min...' text is replaced by '...limit exceeded...' text.
					 the element used for feedback is elements.amountLimitsFeedback
					 elements.amountLimitsFeedback.innerHTML = (limitReached ? textkeysObj['mobile-deposit-limit-reached-text'] : res.amountLimitFeedback);
					 */
					const res = createLimitFeedback({
						max: state.fetch_fees_and_limits.limitMax,
						min: state.fetch_fees_and_limits.limitMin,
						currency: state.fetch_fees_and_limits.selectedCurrency,
						reachmessage: textkeysObj['mobile-deposit-limit-reached-text'],
						belowmessage: textkeysObj['min-limit-exceeded'],
						abovemessage: textkeysObj['max-limit-exceeded'],
						withinmessage: '',
						limitReached,
						above,
						below,
						within
					});
					//elements.inputamount.disabled = limitReached;
					displayFeedback(elements.amountLimitsFeedback, res.amountLimitFeedback);
					/* set text to feedback message and toggle error-style class to inputamount */
					if (limitReached || below || above) {
						core.addClass(elements.inputamount, classnameInputerror);
					} else if (within) {
						core.removeClass(elements.inputamount, classnameInputerror);
					}
				}
			},
			close() {
				// changeHandler = removeListeners(elements.wrap, changeHandler, CHANGE);
				clickHandler = removeListeners(elements.wrap, clickHandler, CLICK);
				focusinHandler = removeListeners(elements.wrap, focusinHandler, FOCUSIN);
				inputHandler = removeListeners(elements.wrap, inputHandler, INPUT);
				elements = core.deleteElementsInObjectExcept(elements, [], 'view-amountinput:224');
				if (viewFirstTimeUkDepositLink) {
					viewFirstTimeUkDepositLink.close();
				}
			}
		};
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/view-amountinput.js